enum HttpMethods {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
}

export default HttpMethods;
